import { useSyncExternalStore } from "react";

/**
 * یک مقدارِ زنده که کامپوننت‌ها به آن گوش می‌دهند.
 *
 * چرا خودمان نوشتیم و کتابخانه نیاوردیم: تنها چیزی که لازم داریم یک مقدارِ
 * قابلِ‌اشتراک بیرون از درختِ ری‌اکت است — وضعیتِ اتصال و آخرین نمای میز از
 * سوکت می‌آیند، نه از رویدادِ کاربر. `useSyncExternalStore` دقیقاً برای همین
 * در خودِ ری‌اکت هست، و این حدودِ بیست خط جای یک وابستگیِ دیگر را می‌گیرد.
 */
export class Signal<T> {
  private subs = new Set<() => void>();

  constructor(private v: T) {}

  get value(): T {
    return this.v;
  }

  set value(next: T) {
    if (Object.is(next, this.v)) return;
    this.v = next;
    for (const fn of [...this.subs]) fn();
  }

  /** تابع‌ها به‌صورتِ فیلد تعریف شده‌اند تا هویتشان ثابت بمانَد؛
      وگرنه useSyncExternalStore هر رندر دوباره مشترک می‌شود. */
  readonly subscribe = (fn: () => void): (() => void) => {
    this.subs.add(fn);
    return () => { this.subs.delete(fn); };
  };

  readonly get = (): T => this.v;
}

export function signal<T>(initial: T): Signal<T> {
  return new Signal(initial);
}

/** خواندنِ سیگنال در یک کامپوننت. با هر تغییر، همان کامپوننت دوباره رندر می‌شود. */
export function useSignal<T>(s: Signal<T>): T {
  return useSyncExternalStore(s.subscribe, s.get, s.get);
}
